import api from './api'

const categoryService = {
  // Récupérer toutes les catégories
  getCategories(actif = true) {
    return api.get('/categories', { params: { actif } })
  },

  // Récupérer une catégorie par ID
  getCategory(id) {
    return api.get(`/categories/${id}`)
  },

  // Récupérer les statistiques des produits par catégorie
  getCategoryStats() {
    return api.get('/categories/stats/products')
  },

  // Créer une nouvelle catégorie (Admin uniquement)
  createCategory(categoryData) {
    return api.post('/categories', categoryData)
  },

  // Modifier une catégorie (Admin uniquement)
  updateCategory(id, categoryData) {
    return api.put(`/categories/${id}`, categoryData)
  },

  // Supprimer une catégorie (Admin uniquement)
  deleteCategory(id) {
    return api.delete(`/categories/${id}`)
  }
}

export default categoryService
